import { Utils } from "src/modules/utils/shared/utils";
import { FrontendScriptNode } from "./frontend-script-node.model";
import { FrontendScriptPastVersion } from "./frontend-script-past-version.model";
import { TreeIcon } from "src/modules/sm-base/models/tree-icon.model";

export class FrontendScriptDefinition {
    id: string;
    name: string;
    sortName: string;
    icons: TreeIcon[] = [];
    parents: string[];
    includes: string[];
    language: string;
    code: string;
    raw: any;
    parentNodes: FrontendScriptNode[];
    version: string;
    pastVersions: FrontendScriptPastVersion[];
    
    getFullName(): string {
        return Utils.arrayItemsToString([...this.parentNodes.map(pn => pn.name), this.name], "->");
    }

    getSortName(): string {
        return this.sortName ?? this.name;
    }
    
}
